import { render, staticRenderFns } from "./ItemsNfeCreate.vue?vue&type=template&id=68b0bd76&"
import script from "./ItemsNfeCreate.vue?vue&type=script&lang=js&"
export * from "./ItemsNfeCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports